import React from 'react';

class IndexLandingPage extends React.Component {

  render () {
    return (

      <div className="wrapper_centering">
        <div className="container_centering">
          <div className="container">
              <div className="row">
                <div className="col-xl-7 col-lg-7 align-items-center">
                  <div className="main_title_1">
                    <a href="https://www.thedeaconphl.com/" target="_blank" rel="noopener noreferrer">
                      <img src="img/deacon-white-bg.png" alt="The Deacon" style={{marginRight: 0, marginBottom: 0}}/>
                    </a>
                    <br></br><br></br><br></br>
                    {/* <h3 className="font-mont">Event RSVP</h3> */}
                    <p className="font-mont">For everyone's safety, we're asking attendees to RSVP with COVID-19 test results before the event. <br></br><br></br>Thank you for your understanding and support! </p>

                  </div>
                  <br></br>
                  <a className="test-link font-mont" href="/host">Are you an event host?</a>

                </div>

                <div className="col-xl-5 col-lg-5" style={{paddingLeft:40}}>
                  {/*<!-- entry point to app -->*/}
                  {this.props.children}

                </div>
              </div>
            </div>
          </div>

      </div>

    );
  }
}

export default IndexLandingPage 